<template lang="html">
  <div id="Projects">
    <div class="background"></div>
    <el-row style="width: 100%;" :gutter="4">
      <el-col :lg="{span:6}" :sm="{span:8}" :xs="{span:24}" v-for="(project, index) of myProjects" :key="index">
        <el-card class="box-card fadeIn" shadow="hover" :body-style="{ padding: '0px' }" v-if="index === 0">
          <div @click="createProject()">
            <div class="gm-align-vertical-center" style="height: 150px;">
              <img class="img-profile" src="@/assets/icon/plus.svg" style="margin: auto;" alt="add icon">
            </div>
            <div style="padding: 0px 8px; height: 60px; text-align: center; vertical-align: bottom;">
              새로운 프로젝트 맵 만들기
            </div>
          </div>
        </el-card>
        <el-card class="box-card fadeIn" shadow="hover" :body-style="{ padding: '0px', background: 'transparent' }" v-else>
          <div>
            <div class="gm-layout-horizontal gm-align-vertical-center">
              <h4 class="name" @click="goToProject(project.pid)">{{ project.name }}</h4>
              <el-popover placement="bottom" width="150" trigger="click" style="margin-left: auto;">
                <!-- Profile -->
                <div id="NavBarPopover" class="gm-layout-vertical">
                  <div class="gm-layout-horizontal gm-align-vertical-center">
                    <vs-icon icon="delete" size="small"></vs-icon>
                    <el-button class="gm-width-match-parent" @click="deleteProject(index, project.name, project.pid)" style="font-size: medium; border: none; margin-left: 0px;">삭제</el-button>
                  </div>
                </div>
                <!-- Popup trigger button -->
                <vs-button class="btn-drop" slot="reference" type="success-gradient" icon="more_vert"></vs-button>
              </el-popover>
            </div>
            <hr />
            <div class="gm-layout-vertical" style="padding: 8px 8px 0px 8px; min-height: 150px;" @click="goToProject(project.pid)">
              <div class="desc">
                <span v-for="line in project.desc.split('\n')" :key="line">
                  {{ line }}<br>
                </span>
              </div>
              <div style="margin-top: auto; padding: 8px; height: 30px;">
                <span>{{ project.createdAt.toDate(), 'YY.MM.DD' | dateFormat }}</span>
                <div style="display: flex; float: right; margin: auto;">
                  <img class="icon" src="@/assets/icon/marker.svg" alt="marker icon">
                  <span style="margin-right: 8px;">{{project.markersNum}}</span>
                  <img class="icon" src="@/assets/icon/person.svg" alt="person icon">
                  <span>{{project.participantsNum}}</span>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { db } from '@/firebase'
export default {
  name: 'Projects',
  components: {},
  firestore() {
    this.uid = 'uid_' + this.$route.params.uid
    this.$log.d('uid', this.uid)
    this.loadProjects()
  },
  data: () => ({
    uid: null,
    myProjects: [{}] // 새로운 프로젝트 만들기를 위한 empty object
  }),
  methods: {
    loadProjects() {
      this.$vs.loading()
      const noProject = () => {
        this.$log.d('no projects')
        this.myProjects = [{}]
        this.$vs.loading.close()
      }
      const uidRef = db.collection('users').doc(this.uid)
      const projectsRef = uidRef.collection('projects')
      projectsRef.get().then(pids => {
        this.$log.d('pids', pids)
        if (pids.empty) {
          noProject()
          return
        }

        let projectLoadedNum = 0
        pids.docs.forEach(pid => {
          this.$log.d('pid', pid)
          projectsRef.doc(pid.id).collection('info').doc('project').get().then(project => {
            this.$log.d('project', project)
            projectLoadedNum++
            this.myProjects.push(project.data())
            if (projectLoadedNum === pids.docs.length) {
              // Load projects completed
              this.$vs.loading.close()
              this.$log.d('this.myProjects', this.myProjects)
            }
          })
        })
      }).catch(err => {
        noProject()
        this.$log.w('error', err)
        if (err.code === 'permission-denied') {
          this.$vs.dialog({
            color: 'danger',
            title: 'Permission denied',
            text: '접근 권한이 없습니다. 메인으로 이동합니다.',
            acceptText: '네. 알겠습니다.',
            accept: _ => {
              this.$router.push('/')
            }
          })
        }
      })
    },
    createProject() {
      this.$router.push('/create')
    },
    goToProject(pid) {
      this.$router.push('/projects/' + this.uid + '/' + pid)
    },
    modifyProject(pid) {
      this.$log.d('modify pid', pid)
    },
    getNumOfMarkersPerTeam(projectIndex) {
      const numOfMarks = this.myProjects[projectIndex].markersNum
      const numOfTeam = this.myProjects[projectIndex].teamsNum
      const numOfMarkersPerTeam = []
      numOfMarkersPerTeam.length = numOfTeam
      numOfMarkersPerTeam.fill(parseInt(numOfMarks / numOfTeam))
      for (let o = 0; o < (numOfMarks % numOfTeam); o++) {
        numOfMarkersPerTeam[o] += 1
      }
      return numOfMarkersPerTeam
    },
    deleteProject(projectIndex, projectName, pid) {
      this.$log.d('delete pid', pid)
      this.$log.d('projectIndex', projectIndex)
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '프로젝트 삭제',
        text: '[' + projectName + '] 프로젝트를 삭제 하시겠습니까? 🙊',
        acceptText: '네. 삭제해주세요.',
        cancelText: '아니요. 잘못 눌렀어요.',
        accept: _ => {
          this.$vs.loading()
          const pidRef = db.collection('users').doc(this.uid).collection('projects').doc(pid)
          // info
          const infoRef = pidRef.collection('info')
          const markersRef = infoRef.doc('markers')
          const projectRef = infoRef.doc('project')

          // state
          const stateRef = pidRef.collection('state')

          let batch = db.batch()

          // 하위 collection 삭제 : info
          batch.delete(markersRef)
          batch.delete(projectRef)

          // 하위 collection 삭제 : state
          const numOfMarkersPerTeam = this.getNumOfMarkersPerTeam(projectIndex)
          for (let i = 0; i < numOfMarkersPerTeam.length; i++) {
            for (let j = 0; j < numOfMarkersPerTeam[i]; j++) {
              // teamIndex + markerIndex
              batch.delete(stateRef.doc(`${i}${j}`))
            }
          }

          // pid 삭제
          batch.delete(pidRef)

          // batch 실행
          batch.commit().then(() => {
            this.myProjects.splice(projectIndex, 1)
            this.$vs.loading.close()
            this.$vs.notify({
              title: '프로젝트 삭제 완료!',
              text: '프로젝트가 삭제되었어요.',
              color: 'success',
              icon: 'done',
              time: 3000,
              position: 'top-center'
            })
          })
        }
      })
    }
  }
}

</script>
<style lang="scss" scoped>
#Projects {
  display: flex;
  height: 100%;
  padding: 16px;

  .background {
    background-image: url('../../assets/projects_background.png');
    position: fixed;
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100%;
    background-position: center;
    background-size: cover;
  }

  .box-card:hover {
    background-color: var(--accent-color);
  }

  .box-card {
    cursor: pointer;
    height: 210px;
    min-height: 200px;
    margin-bottom: 16px;
    font-size: 18px;
    border: 2px solid white;
    color: white;
    background-color: transparent;

    .name {
      padding: 8px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .desc {
      height: 110px;
      overflow: auto;
      /* hidden */
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 7;
      -webkit-box-orient: vertical;
      margin-bottom: 12px;
    }

    .icon {
      height: 20px;
      margin-right: 4px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Projects/index.vue